/* 辅导员API */

import { GET, GETNEW, POST, POSTNEW, download, uploading, POSTFormData, EXPORT, EXPORTNEW, DELETE, DELETENEW } from '@/request/http'

//获取辅导员管理页面数据
export const getInstructorList = p => POSTNEW('/counselor/counselor-info/page', p, 5)
// 获取未成为辅导员用户列表
export const getNoInstructorList = p => POSTNEW('/counselor/counselor-info/findUserList/no-counselor', p, 5)
//批量添加辅导员接口
export const batchAddInstructor = p => POSTNEW('/counselor/counselor-info/add/batch', p, 5)
//增加用户并成为辅导员
export const newInstructor = p => POSTNEW('/counselor/counselor-info/add-user', p, 5)
//获取辅导员档案信息
export const getInstructorArchives = p => GETNEW('/counselor/archives/get/{counselorId}', p, 5)
//获取辅导员个人档案信息
export const getInstructorOneselfInfo = p => GETNEW('/counselor/archives/get', p, 5)
//获取辅导员档案信息
export const exportInstructorList = p => EXPORTNEW('/counselor/counselor-info/export', p, 5)
//获取添加辅导员个人信息的字段
export const getFieldByGroupCode = p => GETNEW('/counselor/archives-config/getByGroupCode', p, 5)
//增加辅导员档案信息
export const saveInstructorInfo = p => POSTNEW('/counselor/archives/save', p, 5)
//修改辅导员档案信息
export const updateInstructorInfo = p => POSTNEW('/counselor/archives/update', p, 5)
//删除辅导员档案信息
export const deleteInstructorInfo = p => DELETENEW('/counselor/archives/remove/{id}', p, 5)
//导出辅导员Pdf
export const exportInstructorColnum = p => GETNEW('/counselor/archives-config/all/list-field', p, 5)

//新增辅导员
export const submitInstructoeInfo = p => POST('/counselor/counselor-info/add', p, 5)

//删除班次
// export const deleteWorkClasses = p => DELETE('/repair/work-shifts/{id}', p, 5)

// 根据部门IO获取为成为管理员的用户列表
export const getNoInstructor = p => GET('/counselor/counselor-info/getUserByDeptId/{id}', p, 5)

// 根据ID获取辅导员信息
export const getInstructorInfoUpdate = p => GET('/counselor/counselor-info/{id}', p, 5)

// 修改辅导员信息
export const editInstructorInfo = p => POSTNEW('/counselor/counselor-info/update', p, 5)

// 删除辅导员信息
export const deleteInstructor = p => DELETENEW('/counselor/counselor-info/{id}', p, 5)

// 获取我的学生页面数据
export const getInsMysStudents = p => POST('/studentv2/counselor-student/findStudentPage', p, 5)

// 新增学生页面 学生信息查询 （弃用）
export const addPopStudentSearch = p => GET('/counselor/counselor-student/relation/getByKeywords/{keywords}', p, 5)

// 添加辅导员下的学生 （弃用）
export const addPopStudentSubmit = p => POST('/counselor/counselor-student/relation/add', p, 5)

// 我的学生页面 删除学生 （弃用）
export const InstructordelStudents = p => POST('/counselor/counselor-student/relation/delete', p, 5)

// 辅导员测评获取页面数据
export const getAppraisalData = p => POST('/counselor/counselor-score/page', p, 5)

// 辅导员测评数据导出
export const appraisalDataExport = p => EXPORT('/counselor/counselor-score/export', p, 4)

// 学生测评明细数据
export const getStuScore = p => POST('/counselor/item-score/stu-score/page', p, 5)

// 学院测评明细数据
export const getFacScore = p => POST('/counselor/item-score/fac-score/page', p, 5)

// 学工处测评明细数据
export const getOffScore = p => POST('/counselor/item-score/off-score/page', p, 5)

// 辅导员职业能力量化考核分数提交接口
export const scoreSave = p => POST('/counselor/counselor-score/qu-assess/score-save', p, 5)

// 获取所有辅导员数据
export const getallInstructorData = p => POST('/counselor/counselor-info/findList/groupbyfac', p, 5)



// WEBPACK FOOTER //
// ./src/api/modules/instructor.js